import React from 'react';
import { Section } from './Section';
import { Button } from './Button';
import { Heart } from 'lucide-react';
export function Hero() {
  return <Section className="pt-24 md:pt-32 lg:pt-40 pb-16 md:pb-24" data-id="element-106">
      <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-107">
        <div className="flex-1 text-center lg:text-left z-10" data-id="element-108">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-rose/10 text-rose-dark font-medium text-sm mb-6" data-id="element-109">
            <Heart className="w-4 h-4 fill-current" data-id="element-110" />
            
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl leading-tight mb-6 text-balance" data-id="element-111">
            Para la mamá que da todo a su bebé pero se siente vacía, hinchada y
            perdida por dentro:
          </h1>

          <p className="text-lg md:text-xl text-brown-light mb-10 font-serif italic text-balance" data-id="element-112">
            esto es lo que nadie más te ha dicho sobre recuperarte de verdad
            después del parto
          </p>

          <div className="flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start" data-id="element-113">
            <Button className="w-full sm:w-auto text-lg px-10 py-5" data-id="element-114">
              🌸 Quiero comenzar mi recuperación posparto hoy
            </Button>
          </div>
        </div>

        <div className="flex-1 relative w-full max-w-md lg:max-w-none mx-auto" data-id="element-115">
          <div className="absolute inset-0 bg-brush-rose rounded-full blur-3xl transform -translate-y-10 scale-110 opacity-70" data-id="element-116"></div>
          <img src="https://cdn.magicpatterns.com/uploads/hTc2ChoyjmWHWN2yfonvgD/ChatGPT_Image_Jun_1,_2026,_08_01_30_PM.png" alt="Renacida Ebook Cover" className="relative z-10 w-full h-auto rounded-lg shadow-2xl transform rotate-2 hover:rotate-0 transition-transform duration-500" data-id="element-117" />
        </div>
      </div>
    </Section>;
}